import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { MessageComponent } from "./components/MessageComponent";

import "./App.css";

function App() {
  const [addingExtranet, setAddingExtranet] = useState(false);
  const [extranets, setExtranets] = useState([]);
  const [display, setDisplay] = useState(false);
  const [displayType, setDisplayType] = useState("success");
  const [message, setMessage] = useState("");
  const [displayLoginDetails, setDisplayLoginDetails] = useState(true);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const suggestExtranet = (data) => {
    axios
        .post("http://localhost:5000/extranets/suggest", data)
        .catch(error => { console.log(error) });
  }

  const onSubmit = (data) => {
    delete data.extranetUrl;
    axios
      .post("http://localhost:5000/clients", data)
      .then((res) => {
        setDisplay(true);
        setDisplayType('success');
        setMessage(res.data.message);

        setAddingExtranet(false);
        setDisplayLoginDetails(false);
      })
      .catch(error => {
        setDisplay(true);
        setDisplayType('error');
        setMessage(error.response.data.message);
      });
  };
  const addExtranet = () => {
    setAddingExtranet((addingExtranet) => !addingExtranet);
  };

  useEffect(() => {
    axios.get('http://localhost:5000/extranets/all').then((res) => {
      setExtranets(res.data);
    });
  }, []);

  return (
    <div className="container mx-auto w-full">
      <form onSubmit={handleSubmit(onSubmit)}>
        {!addingExtranet && (
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Syndicat de copropriétaires
          </label>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded block w-full p-2.5"
            {...register("extranet")}
            required
          >
            <option defaultValue>Sélectionnez un syndicat</option>
            {extranets.map((extranet) => (
                <option key={extranet.id} value={extranet.id}>
                    {extranet.name}
                </option>
            ))}
          </select>
          <div className="text-muted text-sm">
            <p>Sélectionnez le syndicat de copropriétés de votre bien.{" "}
            <button onClick={addExtranet} className="text-violet-700">
              Cliquez ici
            </button>
            {` `}
            {addingExtranet ? (
              <>pour annuler la demande d'ajout.</>
            ) : (
              <>
                pour nous proposer d'en ajouter un si celui que vous recherchez
                n'est pas présent dans la liste.
              </>
            )}</p>
          </div>
        </div>
        )}
        {addingExtranet && (
          <>
            <div className="mb-6">
              <label className="text-sm font-medium text-gray-900 block mb-2">
                Adresse du site internet du syndicat
              </label>
              <input
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded block w-full p-2"
                {...register("extranetUrl")}
              />
              <div className="text-muted text-sm">
                <p>Saisissez l'adresse du site internet de votre syndicat, exemple:
                  https://myfoncia.fr</p>
              </div>
            </div>
          </>
        )}
        {displayLoginDetails && (
            <>
              <div className="mb-6">
                <label className="text-sm font-medium text-gray-900 block mb-2">
                  Identifiant
                </label>
                <input
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded block w-full p-2"
                  {...register("username")}
                  required
                />
                <div className="text-muted text-sm">
                  <p>Saisissez l'identifiant de connexion du compte que vous utilisez
                    pour votre syndicat de copropriétaires.</p>
                </div>
              </div>
              <div className="mb-6">
                <label className="text-sm font-medium text-gray-900 block mb-2">
                  Mot de passe
                </label>
                <input
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded block w-full p-2"
                  type="password"
                  {...register("password")}
                  required
                />
                <div className="text-muted text-sm">
                  Saisissez le mot de passe de votre compte.
                </div>
              </div>
            </>
        )}
        <MessageComponent display={display} message={message} type={displayType} />
        {addingExtranet ? (
          <>
            <button
              onClick={suggestExtranet}
              className="text-white bg-violet-700 hover:bg-violet-800 focus:ring-4 focus:ring-violet-300 font-medium rounded text-sm px-5 py-2.5 text-center"
              type="button"
            >
              Demander l'ajout
            </button>
            <button
                onClick={addExtranet}
                className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded text-sm px-5 py-2.5 ml-2 text-center"
                type="button"
            >
              Annuler
            </button>
          </>
        ) : (
          <button
            className="text-white bg-violet-700 hover:bg-violet-800 focus:ring-4 focus:ring-violet-300 font-medium rounded text-sm px-5 py-2.5 text-center"
            type="submit"
          >
            Valider
          </button>
        )}
      </form>
    </div>
  );
}

export default App;
